<template>
  <div class="app-wrapper" :class="classObj">
    <!-- 移动端遮罩 -->
    <div v-if="device==='mobile' && sidebar.opened" class="sidebar-mask" @click="handleClickMask"></div>

    <!-- 桌面端侧边栏 -->
    <sidebar v-if="device!=='mobile'" class="sidebar-container"></sidebar>

    <!-- 移动端抽屉侧边栏 -->
    <sidebar v-if="device==='mobile'" class="sidebar-mobile"></sidebar>

    <div class="main-container">
      <navbar></navbar>
      <app-main></app-main>
    </div>

    <!-- 移动端底部 Tab 导航 -->
    <mobile-tab-bar v-if="device==='mobile'"></mobile-tab-bar>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, MobileTabBar } from './components'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    MobileTabBar
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
    handleClickMask() {
      this.$store.dispatch('CloseSideBar', { withoutAnimation: false })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
  }
  .sidebar-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.35);
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue